let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8jw80")).then(() => parcelRequire('7grSz'));